// extracted by mini-css-extract-plugin
module.exports = {"root":"OverlayLabel_root__33u4v","topRightBorder":"OverlayLabel_topRightBorder__2tIKL","bottomLeftBorder":"OverlayLabel_bottomLeftBorder__39WbR"};